import { Either } from 'effect'
import type { z } from 'zod'

/**
 * 外から来た文字列（応答の本文、ブラウザに覚えた値）を JSON として読み、スキーマに合えばその値を返す。
 * JSON でないとき（ロードバランサーが返した HTML、壊れた値など）と、形が違うときは null を返す
 */
export const parseJsonText = <T>(text: string, schema: z.ZodType<T>): T | null => {
  const json = Either.try((): unknown => JSON.parse(text))
  const parsed = Either.isRight(json) ? schema.safeParse(json.right) : null
  return parsed?.success === true ? parsed.data : null
}
